import GoalListModel from '@client/models/store/goal/goalListModel';
import {Constants} from '@client/util/constants';
import {toHeaderCurrency} from '@client/util/format';

const stateObj = () => new GoalListModel();

const gettersObj = {
  goalList: (state) => state.goalList,
  goalsToDisplayOnOverview: (state) => state.goalList.filter((goal) => goal.shouldDisplayOnOverview),
  isGoalListLoaded: (state) => state.isGoalListLoaded,
  formattedTotalValue: (state) => {
    if (state.totalValue !== null) {
      return `${Constants.CURRENCY}${toHeaderCurrency(state.totalValue)}`;
    }

    return `${Constants.CURRENCY}0.00`;
  },
  formattedTotalCash: (state) => {
    if (state.totalCash !== null) {
      return `${Constants.CURRENCY}${toHeaderCurrency(state.totalCash)}`;
    }

    return `${Constants.CURRENCY}0.00`;
  },
  searchByGoalId: (state) => (goalId) => state.goalList.filter((goal) => `${goal.goalId}` === `${goalId}`),
};

const actions = {
  async loadGoalList(context) {
    context.commit('setIsGoalListLoaded', false);
    const userId = context.rootGetters['cognitoUser/userId'];

    // This method will call the overview load method to call the bff
    await context.dispatch('overview/getOverviewData', {userId}, {root: true});
  },
  setGoalListClean(context) {
    context.commit('setIsGoalListLoaded', true);
  },
  setGoalListDirty(context) {
    context.commit('setIsGoalListLoaded', false);
  },
};

const mutations = {
  saveGoalList(state, goalInfo) {
    state.isGoalListLoaded = true;
    state.goalList = goalInfo.goals;
    state.totalValue = goalInfo.totalValue;
    state.totalCash = goalInfo.totalCash;
  },
  setIsGoalListLoaded(state, isGoalListLoaded) {
    state.isGoalListLoaded = isGoalListLoaded;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters: gettersObj,
  actions,
  mutations,
};
